import styled from '@emotion/styled'

export const StyleSelectedWrapper = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  border-radius: 8px;
  padding: 15px;
`

export const StyleImageWrapper = styled.div`
  background: ${(props: any) => props.theme.colors.primary600};
  height: 60px;
  width: 60px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const StyleTag = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.white100};
  padding: 5px 7px;
  border-radius: 4px;
  display: flex;
  column-gap: 5px;
  font-size: 12px;
  align-items: center;
  color: ${(props: any) => props.theme.colors.text};
  justify-content: center;
`

export const StyleError = styled.p`
  font-size: 12px;
  color: ${(props: any) => props.theme.colors.danger};
`
